(function () {
  const initProductAccordion = () => {
    const aboutToggleItems = $(".about__accordion-toggle");

    aboutToggleItems.each(function() {
      const currentToggle = $(this);
      const siblingToggles = currentToggle.siblings(".about__accordion-description");

      currentToggle.click(function () {
        if (!currentToggle.hasClass("active")) {
          aboutToggleItems.each(function () {
            const siblingToggle = $(this);
            siblingToggle.removeClass("active");
            siblingToggle.siblings(".about__accordion-description").stop().slideUp(300);
          });

          currentToggle.addClass("active");

          siblingToggles.stop().slideDown(300);
        } else {
          currentToggle.removeClass("active");
          siblingToggles.stop().slideUp(300);
        }
      });
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector(".product-media-modal__content");
    const images = imagesWrapper?.querySelectorAll(".js-image-zoom") || [];

    images.forEach((el) => {
      el.addEventListener("click", (e) => {
        imagesWrapper.classList.toggle("zoom");
      });
    });
  };

  const formatFreeShippingAmount = (value) => {
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = theme.moneyFormat;

    return formatString.replace(placeholderRegex, value);
  }

  const setTotalFreeShipping = () => {
    if (document.querySelector('.js-free-shipping')) {
      const freeShippingTotal = document.querySelector('.free-shipping-total');
      if (freeShippingTotal) {
        const minSpend = Number(freeShippingTotal.dataset.minSpend);
        if (minSpend && minSpend > 0) {
          freeShippingTotal.innerText = `${formatFreeShippingAmount(Math.round(minSpend * (Shopify.currency.rate || 1)))}`;
        }
      }
    }
  }

  function formatTimeDifference(targetDate) {
    const currentDate = new Date();
    
    const difference = targetDate - currentDate;
    
    const seconds = Math.floor((difference / 1000) % 60);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));

    return `${String(days).padStart(2, '0')} days, ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  const showFlashSale = (time) => {
    return (time.getTime() - Date.now()) > 0;
  }

  const initFlashSale = () => {
    if (document.querySelector('.flash-sale')) {
      const flashsale = document.querySelector('.flash-sale');

      try {
        const timeString = flashsale.getAttribute('data-end');

        const time = new Date(timeString);

        if (showFlashSale(time)) {
          flashsale.innerHTML = `Sale ends in ${formatTimeDifference(time)}`;
  
          const interval = setInterval(() => {
            if (showFlashSale(time)) {
              flashsale.innerHTML = `Sale ends in ${formatTimeDifference(time)}`;
            } else {
              clearInteval(interval);
            }
          }, 1000);
        } 
      } catch (error) {
        console.error(error);
      }
    }
  }

  document.addEventListener("shopify:section:load", function () {
    initProductAccordion();
    initZoomImage();
    setTotalFreeShipping();
  });

  initProductAccordion();
  initZoomImage();
  setTotalFreeShipping();
  initFlashSale();
})();
